import { CategoryTree } from '@/fo/api/magento';
import {
  DEFAULT_SORT_OPTION,
  SORT_DIRECTION,
  SORT_OPTIONS_MAP,
  SelectedFilters
} from '@/fo/ui/product/layout/catalog';

import { GetProductsProps } from '../api/getProducts';
import { PAGE_SIZE } from '../constants';
import { DefaultCategoryPath } from '../types';

import { getCategoryType } from './getCategoryType';

export const formatCategoryParams = ({
  search,
  filtersParams,
  paginationParams,
  sortValue,
  defaultCategoryPath,
  category
}: {
  search?: string;
  filtersParams: SelectedFilters;
  paginationParams: { count: number; page: number };
  sortValue: string;
  defaultCategoryPath?: DefaultCategoryPath;
  category?: CategoryTree;
}): GetProductsProps => {
  const { category_url_path, category_id, category_uid, ...otherFilters } =
    filtersParams || {};

  const { page } = paginationParams;

  const categoryParams = getCategoryType({
    category_url_path: category_url_path as string[] | string | undefined,
    category_id: category_id as string[] | string | undefined,
    category_uid: category_uid as string[] | string | undefined,
    defaultCategoryPath,
    category
  });

  const sortOption = SORT_OPTIONS_MAP[sortValue] || DEFAULT_SORT_OPTION;
  const sort =
    sortOption.value === 'popularity'
      ? {
          position: SORT_DIRECTION.DESC,
          [sortOption.value]: sortOption.direction
        }
      : { [sortOption.value]: sortOption.direction };

  return {
    search,
    filtersQuery: {
      ...categoryParams,
      ...otherFilters
    },
    pageSize: PAGE_SIZE,
    currentPage: page,
    sort
  };
};
